import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const dialogModalFn = /* @__PURE__ */ createRecipe('dialogModal', {}, [])

const dialogModalVariantMap = {}

const dialogModalVariantKeys = Object.keys(dialogModalVariantMap)

export const dialogModal = /* @__PURE__ */ Object.assign(memo(dialogModalFn.recipeFn), {
  __recipe__: true,
  __name__: 'dialogModal',
  __getCompoundVariantCss__: dialogModalFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: dialogModalVariantKeys,
  variantMap: dialogModalVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, dialogModalVariantKeys)
  },
  getVariantProps: dialogModalFn.getVariantProps,
})